import script from "./SelectStaffSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectStaffSearch.vue?vue&type=script&lang=ts&setup=true"

import "./SelectStaffSearch.vue?vue&type=style&index=0&id=39aa2a49&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ayaka_kitahara\\source\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39aa2a49"]])

export default __exports__